export default __webpack_public_path__ + "static/testimonialCompanyLogo2-ad422a3be37851da4a4e215c55c59bef.svg";